<template>
  <div
    :class="computedClassList"
    class="jade-status-tracker__content"
  >
    <jade-text
      :weight="computedLabelWeight"
      class="jade-status-tracker__label"
      color="current-color"
      data-testid="text-label"
      variant="text-large"
      >{{ label }}</jade-text
    >
    <jade-text
      v-if="description"
      color="medium"
      data-testid="text-description"
      variant="text-medium"
      weight="regular"
      >{{ description }}</jade-text
    >
    <jade-link
      v-if="isValidLink"
      :href="$sanitize(link.href)"
      :external="link?.external"
      :target="link?.target"
      as="a"
      variant="brand"
      weight="semibold"
      data-testid="jade-link"
      rel="noopener noreferrer"
      >{{ link.label }}</jade-link
    >
  </div>
</template>

<script>
import STATUS_TRACKER_OPTIONS_ENUM from '../status-tracker-options.enum'
import WEIGHT_ENUM from '../../enums/weight.enum'
import { JadeText, JadeLink } from '../../index'

export default {
  name: 'JadeStatusTrackerContent',
  components: {
    JadeText,
    JadeLink
  },
  props: {
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      required: true,
      validation: status =>
        Object.values(STATUS_TRACKER_OPTIONS_ENUM).includes(status)
    },
    link: {
      type: Object,
      default: () => {
        return {
          href: '',
          label: ''
        }
      }
    }
  },
  computed: {
    isValidLink () {
      return this.link?.href?.length && this.link?.label?.length
    },
    computedClassList () {
      return {
        [`is-${this.status}`]: this.status
      }
    },
    computedLabelWeight () {
      return [
        STATUS_TRACKER_OPTIONS_ENUM.COMPLETED,
        STATUS_TRACKER_OPTIONS_ENUM.NEXT
      ].includes(this.status)
        ? WEIGHT_ENUM.MEDIUM
        : WEIGHT_ENUM.SEMI_BOLD
    }
  }
}
</script>
